import { makeStyles } from '@material-ui/core';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const useStyles = makeStyles(() => ({
	root: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
}));

const ImageKit = (props) => {
	const classes = useStyles();

	return (
		<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
			<LazyLoadImage className={classes.root} {...props} />
		</div>
	);
};

ImageKit.defaultProps = {
	effect: 'blur',
	width: 'auto',
	height: 'auto',
	src: '',
	alt: 'keepa',
	afterLoad: () => ({}),
	beforeLoad: () => ({}),
	delayMethod: 'throttle',
	delayTime: 300,
	placeholderSrc: null,
	threshold: 100,
	useIntersectionObserver: true,
	visibleByDefault: false,
	wrapperClassName: '',
};

export default ImageKit;
